/* @flow */

import React from 'react';
import classnames from 'classnames';
import {
    BarChart as RechartsBarChart,
    Bar as RechartsBar,
    LineChart as RechartsLineChart,
    Line as RechartsLine
} from 'recharts';

import Brush from './Brush';

import { DistinctColors } from 'common/enums/ColorEnum';
import { type DataKeyType } from 'common/components/core/charts/_shared/CartesianChartDataType';

import theme from './Brush.scss';
const [DEFAULT_COLOR] = DistinctColors;

type Options = {
    chartType: 'BAR' | 'LINE',
    filteredDataKeys: Array<DataKeyType>,
    onBrushChange: (params: { startIndex: number, endIndex: number }) => void,
    domainAxisKey: string,
    formattedValues: $FixMe
};

export const createBrush = ({
    chartType,
    filteredDataKeys,
    onBrushChange,
    domainAxisKey,
    formattedValues
}: Options) => {
    const dataLength = formattedValues.length;
    return (
        <Brush
            gap={1}
            endIndex={Math.round(dataLength / 4)}
            dataKey={domainAxisKey}
            onChange={onBrushChange}
            textRenderer={getTextRenderer(theme)}
        >
            {chartType === 'BAR' ? (
                <RechartsBarChart>
                    {filteredDataKeys.map(dataKey => {
                        return (
                            <RechartsBar
                                key={dataKey.key}
                                fill={dataKey.color || DEFAULT_COLOR}
                                dataKey={dataKey.key}
                                stackId={dataKey.stackId}
                                isAnimationActive={false}
                            />
                        );
                    })}
                </RechartsBarChart>
            ) : chartType === 'LINE' ? (
                <RechartsLineChart data={formattedValues}>
                    {filteredDataKeys.map(dataKey => {
                        return (
                            <RechartsLine
                                type={'monotoneX'}
                                key={dataKey.key}
                                dataKey={dataKey.key}
                                name={dataKey.label}
                                dot={false}
                                stroke={dataKey.color || DEFAULT_COLOR}
                                strokeWidth={0.8}
                                strokeOpacity={1}
                                isAnimationActive={false}
                            />
                        );
                    })}
                </RechartsLineChart>
            ) : (
                []
            )}
        </Brush>
    );
};

const getTextRenderer = theme => {
    return <TextRender theme={theme} />;
};

const TextRender = props => {
    const { theme, x, y, height, type, value } = props;
    return (
        <svg x={x} y={y + height + 5} xmlns="http://www.w3.org/2000/svg">
            <foreignObject width={100} height={20}>
                <div
                    className={classnames(theme.brushText, {
                        [theme[type.toLowerCase()]]: type
                    })}
                    xmlns="http://www.w3.org/1999/xhtml"
                >
                    <span className={theme.text} title={value}>
                        {value}
                    </span>
                </div>
            </foreignObject>
        </svg>
    );
};
